import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';

export class DentureDetailsUtils {
	public static isDentureDetailsEnabled(procedureId: number): boolean {
		return procedureId === ProcedureEnum.Denture_Removable;
	}
}
